import { BG_SCHEMA, SUBTITLE_SCHEMA, TITLE_SCHEMA } from '../common/content'
import { commonBeforeParseMethod, commonGetIdMethod } from '../helpers'

export const SCHEDULE_SCHEMA = config => {
  const {id, idLayout, pageId} = commonGetIdMethod(config)

  return {
    type: 'schedule',
    id: id,
    idLayout: idLayout,
    pageId: pageId,
    name: '',
    bg: BG_SCHEMA(),
    title: TITLE_SCHEMA('Programação'),
    subtitle: SUBTITLE_SCHEMA(),
    'accent-color': '#000000',
    'item-background-color': '#f5f5f5'
  }
}

export const beforeParseSchedule = target => {
  commonBeforeParseMethod(target, ['bg'])
}

export const SCHEDULE_SECTION = config => ({
  schema: SCHEDULE_SCHEMA(config),
  beforeParse: beforeParseSchedule
})
